import { Component } from '@angular/core';
import { GloTagComponent } from "../../../../shared/components/tag/tag.component";
import { GloControlComponent } from "../../../../shared/components/glo-control/glo-control.component";
import { NgFor, NgIf, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { GloTabContentDirective, GloTabsComponent } from "../../../../shared/components/tabs/tabs.component";
import { GloPaginationComponent } from "../../../../shared/components/pagination/pagination.component";
import { environment } from '../../../../../environments/environment';

export interface Salon {
  name: string;
  rating: number;
  reviews: number;
  distance: string;
  location: string;
  tags: string[];
  image: string;
  isPopular: boolean;
}

@Component({
    selector: 'landing-explore',
    imports: [GloTagComponent, GloControlComponent, NgFor, RouterLink, NgIf, NgStyle, GloTabsComponent, GloTabContentDirective, GloPaginationComponent],
    templateUrl: './explore.component.html',
    styleUrl: './explore.component.scss'
})
export class ExploreComponent {
    assetUrl = environment.assetBaseUrl

    activeTab: string = 'near-me';
    tabs = [
      { key: 'near-me', label: 'Near Me' },
      { key: 'top-rated', label: 'Top Rated' },
      { key: 'budget', label: 'Budget-Friendly' },
      { key: 'promo', label: 'Specials Promo' },
    ];
    salons: Salon[] = [
      {
        name: 'Soho Studio Plus',
        rating: 4.7,
        reviews: 188,
        distance: '1.2 km',
        location: "Dolphin's Barn Street",
        tags: ['Hair', 'Coloring', 'Hair Removal'],
        image: this.assetUrl + 'img/mock-salon1.png',
        isPopular: true
      },
      {
        name: 'Soho Studio Plus',
        rating: 4.7,
        reviews: 188,
        distance: '1.2 km',
        location: "Dolphin's Barn Street",
        tags: ['Hair', 'Coloring', 'Hair Removal'],
        image: this.assetUrl + 'img/salon-details2.png',
        isPopular: false
      },
      {
        name: 'Soho Studio Plus',
        rating: 4.7,
        reviews: 188,
        distance: '1.2 km',
        location: "Dolphin's Barn Street",
        tags: ['Hair', 'Coloring', 'Hair Removal'],
        image: this.assetUrl + 'img/mock-salon1.png',
        isPopular: true
      },
      {
        name: 'Soho Studio Plus',
        rating: 4.7,
        reviews: 188,
        distance: '1.2 km',
        location: "Dolphin's Barn Street",
        tags: ['Hair', 'Coloring', 'Hair Removal'],
        image: this.assetUrl + 'img/salon-details2.png',
        isPopular: false
      },
      {
        name: 'Soho Studio Plus',
        rating: 4.7,
        reviews: 188,
        distance: '1.2 km',
        location: "Dolphin's Barn Street",
        tags: ['Hair', 'Coloring', 'Hair Removal'],
        image: this.assetUrl + 'img/salon-details2.png',
        isPopular: false
      },
      {
        name: 'Soho Studio Plus',
        rating: 4.7,
        reviews: 188,
        distance: '1.2 km',
        location: "Dolphin's Barn Street",
        tags: ['Hair', 'Coloring', 'Hair Removal'],
        image: this.assetUrl + 'img/mock-salon1.png',
        isPopular: true
      },
    ];
    currentPage = 1;
    pageSize = 4;

    onPageChange(newPage: number) {
      this.currentPage = newPage;
    }

    get totalPages(): number {
      return Math.ceil(this.salons.length / this.pageSize);
    }
}
